export const STRIPE = 1;
export const SSLCOMMERZ = 2;
export const MANUAL = 3;
export const SHURJO_PAY = 4;
